import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { AtributosProjeto } from 'src/app/shared/models/atributos-projeto.model';

@Injectable({
  providedIn: 'root',
})
export class AtributosProjetoService extends BaseService<AtributosProjeto>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getPathModule(): string {
    return '/atributos-projeto';
  }
}
